/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const BookLayoutPreferenceEnum = Object.freeze({
	ALTERNATE_SIDES: "ALTERNATE_SIDES",
	IMAGES_LEFT: "IMAGES_LEFT",
	IMAGES_RIGHT: "IMAGES_RIGHT",
	IMAGES_ABOVE: "IMAGES_ABOVE",
	IMAGES_BELOW: "IMAGES_BELOW",
	IMAGES_WITHIN_TEXT: "IMAGES_WITHIN_TEXT",
})

export function titleForBookLayoutPreference(layoutPreference) {
	switch (layoutPreference) {
		case BookLayoutPreferenceEnum.IMAGES_LEFT:
			return "Images left"
		case BookLayoutPreferenceEnum.IMAGES_RIGHT:
			return "Images right"
		case BookLayoutPreferenceEnum.IMAGES_ABOVE:
			return "Images above"
		case BookLayoutPreferenceEnum.IMAGES_BELOW:
			return "Images below"
		case BookLayoutPreferenceEnum.IMAGES_WITHIN_TEXT:
			return "Images within text"
		default:
			return "Alternate sides"
	}
}

